import { render, staticRenderFns } from "./PasswordLost.vue?vue&type=template&id=5f665d6a&"
import script from "./PasswordLost.vue?vue&type=script&lang=js&"
export * from "./PasswordLost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports